// PrivacyPolicy.js
import React from 'react';
import { Card, Typography, Divider } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <Card>
        <Title level={1}>Privacy Policy</Title>
        <Text type="secondary" style={{ fontSize: '14px' }}>
          Last Updated: {new Date().toLocaleDateString()}
        </Text>
        
        <Divider />
        
        <Paragraph>
          Your privacy is important to us. It is HRM360's policy to respect your privacy regarding any information we may collect from you across our website, hrm360.softomation.com, and other sites we own and operate.
        </Paragraph>

        <Title level={2}>1. Information We Collect</Title>
        <Paragraph>
          We only collect information about you if we have a reason to do so — for example, to provide our Services, to communicate with you, or to make our Services better.
        </Paragraph>

        <Title level={3}>1.1 Personal Information</Title>
        <Paragraph>
          We collect personal information that you provide to us, such as:
          <ul>
            <li>Name, email address, phone number</li>
            <li>Employee identification details</li>
            <li>Job title, department, and employment information</li>
            <li>Profile photos and biometric data (for attendance purposes)</li>
          </ul>
        </Paragraph>

        <Title level={3}>1.2 Location Data</Title>
        <Paragraph>
          HRM360 captures your location to mark attendance. We collect location data only when the app is in use to ensure accurate attendance tracking. Your location data is not shared with third parties and is used solely for attendance purposes.
        </Paragraph>

        <Title level={3}>1.3 Device Information</Title>
        <Paragraph>
          To provide a better experience, we require the Android permission `READ_PHONE_STATE` to access information about your device. This permission allows us to gather information about your device's state to ensure the app functions correctly. We may collect:
          <ul>
            <li>Device model and operating system</li>
            <li>Unique device identifiers</li>
            <li>IP address and browser type</li>
            <li>Usage data and app interactions</li>
          </ul>
        </Paragraph>

        <Title level={3}>1.4 Cookies and Tracking Technologies</Title>
        <Paragraph>
          We use cookies and similar tracking technologies to track activity on our service and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier.
        </Paragraph>

        <Title level={2}>2. How We Use Information</Title>
        <Paragraph>
          We use information about you as mentioned above and for the purposes listed below:
          <ul>
            <li>To provide our services and manage your account</li>
            <li>To process and manage attendance, payroll, and HR-related functions</li>
            <li>To further develop and improve our services</li>
            <li>To monitor and analyze trends and better understand how users interact with our services</li>
            <li>To monitor and protect the security of our information, systems, and network</li>
            <li>To send you administrative information, updates, and notifications</li>
            <li>To respond to your inquiries and provide customer support</li>
          </ul>
        </Paragraph>

        <Title level={2}>3. Information Sharing and Disclosure</Title>
        <Paragraph>
          We do not share any personally identifying information publicly or with third-parties, except when required to by law. We may share your information in the following circumstances:
        </Paragraph>
        <Paragraph>
          <ul>
            <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
            <li><strong>Service Providers:</strong> We may employ third-party companies and individuals to facilitate our service, provide service on our behalf, or assist us in analyzing how our service is used. These third parties have access to your personal data only to perform these tasks on our behalf.</li>
            <li><strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or asset sale, your personal data may be transferred.</li>
            <li><strong>With Your Consent:</strong> We may share your information with your explicit consent.</li>
          </ul>
        </Paragraph>

        <Title level={2}>4. Data Security</Title>
        <Paragraph>
          We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
        </Paragraph>

        <Title level={2}>5. Data Retention</Title>
        <Paragraph>
          We will retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
        </Paragraph>

        <Title level={2}>6. Your Privacy Rights</Title>
        <Paragraph>
          You have the right to:
          <ul>
            <li><strong>Access:</strong> Request access to the personal data we have collected about you</li>
            <li><strong>Correction:</strong> Request the correction of inaccurate or incomplete personal data</li>
            <li><strong>Deletion:</strong> Request the deletion of your personal data (subject to legal requirements)</li>
            <li><strong>Portability:</strong> Request transfer of your personal data to another service provider</li>
            <li><strong>Objection:</strong> Object to processing of your personal data in certain circumstances</li>
            <li><strong>Withdrawal of Consent:</strong> Withdraw consent where processing is based on consent</li>
          </ul>
        </Paragraph>
        <Paragraph>
          To exercise these rights, please contact us or visit our <Link to="/delete-account">Data Deletion page</Link>.
        </Paragraph>

        <Title level={2}>7. Children's Privacy</Title>
        <Paragraph>
          Our service does not address anyone under the age of 18. We do not knowingly collect personal information from children under 18.
        </Paragraph>

        <Title level={2}>8. International Data Transfers</Title>
        <Paragraph>
          Your information may be transferred to and maintained on computers located outside of your state, province, country, or other governmental jurisdiction where data protection laws may differ from those of your jurisdiction.
        </Paragraph>

        <Title level={2}>9. Changes to This Privacy Policy</Title>
        <Paragraph>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. We encourage you to review this Privacy Policy periodically for any changes.
        </Paragraph>

        <Title level={2}>10. Contact Us</Title>
        <Paragraph>
          If you have any questions about this Privacy Policy or wish to exercise your privacy rights, please contact us:
          <ul>
            <li>Email: support@softomation.com</li>
            <li>Website: <a href="https://softomation.com" target="_blank" rel="noopener noreferrer">https://softomation.com</a></li>
          </ul>
        </Paragraph>

        <Divider />
        
        <Paragraph>
          <Text type="secondary">
            By using our service, you acknowledge that you have read and understood this Privacy Policy.
          </Text>
        </Paragraph>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;
